import { isIdEqual } from 'modules/enumerations/enumerationHelpers';
import { RECURRING_PAYABLE_STATUS } from 'modules/enumerations/enumerationIds';

export const RECURRING_PAYABLE_STATUS_LABEL = {
  [RECURRING_PAYABLE_STATUS.NOT_APPLICABLE]: '',
  [RECURRING_PAYABLE_STATUS.ACTIVE]: 'Active',
  [RECURRING_PAYABLE_STATUS.PENDING]: 'Pending',
  [RECURRING_PAYABLE_STATUS.EXPIRED]: 'Expired',
  [RECURRING_PAYABLE_STATUS.CANCELLED]: 'Cancelled',
  [RECURRING_PAYABLE_STATUS.DRAFT]: 'Draft'
};

const hasText = s => typeof s === 'string' && s.trim().length > 0;

export const isOnHold = ({ rp }) => !!rp && hasText(rp.onHoldReason);
export const isDenied = ({ rp }) => !!rp && hasText(rp.denyReason);

export const equalsIgnoreCase = (a, b) => !!a && !!b && a.toLowerCase() === b.toLowerCase();

export const hasStatus = (rp, statusId) => {
  const byId = isIdEqual(rp?.recurringPayableStatusId, statusId);
  return byId;
};

export const canEditRP = rp =>
  !!rp?.recurringPayableStatusId &&
  (hasStatus(rp, RECURRING_PAYABLE_STATUS.DRAFT) ||
    hasStatus(rp, RECURRING_PAYABLE_STATUS.PENDING) ||
    hasStatus(rp, RECURRING_PAYABLE_STATUS.NOT_APPLICABLE) ||
    isOnHold(rp));

export const canSubmitForApproval = rp =>
  !!rp?.recurringPayableStatusId &&
  (hasStatus(rp, RECURRING_PAYABLE_STATUS.DRAFT) || hasStatus(rp, RECURRING_PAYABLE_STATUS.NOT_APPLICABLE) || isOnHold(rp));

export const canCancelRP = rp =>
  !!rp?.recurringPayableStatusId &&
  !hasStatus(rp, RECURRING_PAYABLE_STATUS.CANCELLED) &&
  !hasStatus(rp, RECURRING_PAYABLE_STATUS.EXPIRED) &&
  !isDenied(rp);

export const isLocked = rp =>
  !!rp?.recurringPayableStatusId &&
  (hasStatus(rp, RECURRING_PAYABLE_STATUS.CANCELLED) || hasStatus(rp, RECURRING_PAYABLE_STATUS.EXPIRED) || isDenied(rp));

export const showScheduleSection = rp => !!rp?.recurringPayableStatusId && hasStatus(rp, RECURRING_PAYABLE_STATUS.ACTIVE);

export const getEffectiveStatus = rpi => {
  const deny = (rpi?.denyReason ?? '').trim().length > 0;
  if (deny) return 'DENIED';

  const hold = (rpi?.onHoldReason ?? '').trim().length > 0;
  if (hold) return 'ON HOLD';

  const id = rpi?.recurringPayableStatusId;
  if (isIdEqual(id, RECURRING_PAYABLE_STATUS.DRAFT)) return 'DRAFT';
  if (isIdEqual(id, RECURRING_PAYABLE_STATUS.PENDING)) return 'PENDING';
  if (isIdEqual(id, RECURRING_PAYABLE_STATUS.ACTIVE)) return 'ACTIVE';
  if (isIdEqual(id, RECURRING_PAYABLE_STATUS.CANCELLED)) return 'CANCELLED';
  if (isIdEqual(id, RECURRING_PAYABLE_STATUS.EXPIRED)) return 'EXPIRED';

  return 'DRAFT';
};
